import { Row, Checkbox, Col, Card, Space, Button, message } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { fetchTags, deleteTags } from 'services/tag';

/**
 * Return ItemDetailDialog
 * @param {ItemDetailDialogProps} props
 * @returns {JSX.Element}
 */
type Props = {
  tabsActiveKey: string;
};
const TagManage = (props: Props) => {
  const { tabsActiveKey } = props;
  const [tags, setTags] = useState<TagRow[]>([]);
  const [checkedList, setCheckedList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);

  const getTagList = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetchTags(3);
      setLoading(false);
      setTags(res);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, []);

  const delTags = useCallback(async () => {
    try {
      setSaveLoading(true);
      const res = await deleteTags(checkedList);
      setSaveLoading(false);
      if (res.isSuccess) {
        message.success('Delete Tags Successfully');
        setCheckedList([]);
        getTagList();
      }
    } catch (error) {
      setSaveLoading(false);
    }
  }, [checkedList, getTagList]);

  useEffect(() => {
    if (tabsActiveKey === '3') {
      getTagList();
    }
  }, [getTagList, tabsActiveKey]);

  return (
    <Card loading={loading}>
      <Row justify="start" style={{ marginBottom: 12 }}>
        <Space>
          <Button
            onClick={() => {
              const temp = tags.map((i) => i.tagNum);
              setCheckedList(temp);
            }}
          >
            Select All
          </Button>
          <Button
            onClick={() => {
              setCheckedList([]);
            }}
          >
            Unselect All
          </Button>
          <Button
            type="primary"
            loading={saveLoading}
            disabled={checkedList.length === 0}
            onClick={() => {
              delTags();
            }}
          >
            Delete Selected Tags
          </Button>
        </Space>
      </Row>
      <Checkbox.Group
        style={{ width: '100%', maxWidth: 1200 }}
        value={checkedList}
        onChange={setCheckedList}
      >
        <Row>
          {tags.map((i) => (
            <Col span={8}>
              <Checkbox key={i.tagNum} value={i.tagNum}>
                {i.tagName}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Checkbox.Group>
    </Card>
  );
};
export default TagManage